import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import App from './App'
import Vue from 'vue'
import './uni.promisify.adaptor'
import store from './store/index.js'
import uView from "uview-ui";
Vue.use(uView);

import AuthLogin from '@/components/auth-login/auth-login.vue'
Vue.component('auth-login', AuthLogin)

Vue.config.productionTip = false
App.mpType = 'app'
Vue.prototype.$store = store;

store.dispatch('getHeight') // 获取系统状态栏高度/手机型号
Vue.prototype.$onLaunched = new Promise(resolve => {
	Vue.prototype.$isResolve = resolve;
})

Vue.prototype.$baseUrl = 'https://test.doumee.cn/gtzxljc_web'
// Vue.prototype.$baseUrl = 'http://192.168.1.22:10011'
// Vue.prototype.$baseUrl = 'https://llfc.lmpro.cn/nyx_web/'
Vue.prototype.$gaodeMapKey = 'e4d46c87adf151dca20060317592b1b6'

const app = new Vue({
	store,
	...App
})


// http接口API抽离
import httpApi from '@/utils/http.api.js'
Vue.use(httpApi, app)

// 请求拦截器
import interceptor from '@/utils/http.interceptor.js'
Vue.use(interceptor, app)

app.$mount()